import { TypesAction } from "../components/widgets/smart-table/interfaces/actions";

export enum ButtonTypeENUM {
  INSERT = "insert",
  UPDATE = "update",
  DELETE = "delete",
}

export type ButtonType = TypesAction | ButtonTypeENUM;

const actionMap: Record<string, ButtonTypeENUM | undefined> = {
  "edit": ButtonTypeENUM.UPDATE,
  "download": undefined,
  "preview": undefined,
  "remove": ButtonTypeENUM.DELETE,
  "dissocia": ButtonTypeENUM.DELETE,
  "dissociastr": ButtonTypeENUM.DELETE,
  "viewobs": undefined,
};

export function mapToButtonType(action: string): ButtonType {
  return actionMap[action] ?? action as ButtonType;
}

